<ul class="checklist">
  @for (item of items(); track item.text) {
    <li>
      <htx-icon [icon]="item.icon || icon()"></htx-icon>
      <span [innerHTML]="item.text"></span>
    </li>
  }
</ul>
